import LessonDescriptionEditor from '../component/LessonDescriptionEditor';

interface LessonDescriptionPageProps {
    brief: string;
    advancedContext: string;
    onBriefChange: (value: string) => void;
    onAdvancedContextChange: (value: string) => void;
    onContinue: () => void;
}

export default function LessonDescriptionPage(props: LessonDescriptionPageProps) {
    return (
        <LessonDescriptionEditor
            brief={props.brief}
            advancedContext={props.advancedContext}
            onBriefChange={props.onBriefChange}
            onAdvancedContextChange={props.onAdvancedContextChange}
            onCreateOutline={props.onContinue}
        />
    );
}
